import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import Layout from './components/Layout';
import { UserContextComponent } from './context/UserContext';
import { SearchParamsContextComponent } from './context/SearchParamsContext';
import CreateResetPassword from './pages/Authentication/CreateResetPassword';
import ForgotPassword from './pages/Authentication/ForgotPassword';
import LogIn from './pages/Authentication/LogIn';
import 'semantic-ui-css/semantic.min.css';
import Home from './pages/Home';
import OrderDetails from './pages/OrderDetails';
import OrderEntryPage from './pages/OrderEntry';
import SuccessPage from './pages/OrderEntry/SuccessPage';
import NotFound from './pages/NotFound';
import GlobalError from './pages/ErrorPage';
import { OrderEntryProvider } from './pages/OrderEntry/OrderEntryContext';
import LogRocket from 'logrocket';
import axios from 'axios';
import './index.css';
import Settings from './pages/Settings';
import InvoicePage from './pages/InvoicePage/InvoicePage';
import AddressLookup from './pages/AddressLookup';
import PropertyInfo from './pages/AddressLookup/PropertyInfo';
import { AddPropertyProvider } from './pages/OrderDetails/AddProperty/AddPropertyContext';

LogRocket.init('ifcujv/hudpro', {
  rootHostname: 'internal.hudsonsearch.com',
});

const App = () => {
  const [globalError, setGlobalError] = useState(false);

  useEffect(() => {
    axios.interceptors.response.use(null, function (error) {
      if (error.message.toLowerCase() === 'request failed with status code 500') {
        setGlobalError(true);
      }
      return { data: [] };
    });
  }, []);
  return (
    <UserContextComponent>
      <QueryParamProvider ReactRouterRoute={Route}>
        <SearchParamsContextComponent>
          <Switch>
            <Redirect exact from="/" to="/login" />
            {globalError && <Route exact component={GlobalError} />}
            <Route exact path="/login" component={LogIn} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route
              exact
              path="/reset-password/:token"
              component={() => (
                <CreateResetPassword header="Reset Password" buttonText="Log In" linkButton reset />
              )}
            />
            <Route
              exact
              path="/activate/:token"
              component={() => (
                <CreateResetPassword header="Create Password" buttonText="Sign Up" subHeader />
              )}
            />
            <Route exact path="/home" component={Home} />
            <Route exact path="/order/:orderId" 
             render={() => (
                <AddPropertyProvider>
                  <OrderDetails />
                </AddPropertyProvider>
              )} />
            <Route exact path="/settings/:tab?" component={Settings} />
            <Route
              exact
              path="/new-order/:propertyId?/:location?"
              render={() => (
                <OrderEntryProvider>
                  <OrderEntryPage />
                </OrderEntryProvider>
              )}
            />
            <Route exact path="/billingStatement/:orderId/:titleNumber" component={InvoicePage} />
            <Route exact path={'/address-lookup'} component={AddressLookup} />
            <Route exact path={'/property-info/:propertyId/:location'} component={PropertyInfo} />
            <Route exact path={'/order-confirmation/success/:orderId'} component={SuccessPage} />
            <Route exact component={NotFound} />
          </Switch>
        </SearchParamsContextComponent>
      </QueryParamProvider>
    </UserContextComponent>
  );
};

export default App;
